import { render, staticRenderFns } from "./ClientPJ.vue?vue&type=template&id=41e4d66a"
import script from "./ClientPJ.vue?vue&type=script&lang=js"
export * from "./ClientPJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports